// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
Content styles is attached to the editor iframe and only affects the contents

-tpi- classes are randomly assigned to telepointers, and may be used by multiple telepointers at the same time.

TODO: we have added 10 of 12 new colors
colors in the spec that has not been added:
R100 / #FF8F73 - .synchrony-tpi-10
P100 / #998DD9 - .synchrony-tpi-11
we will need to create more synchrony classes to include (.synchrony-tpi-10 && .synchrony-tpi-11)
does not exist yet.
*/

/* stylelint-disable design-system/ensure-design-token-usage */
.adg3-editor .synchrony-tpi-0 {
	background-color: #172b4d;
}

.adg3-editor .synchrony-tpi-1 {
	background-color: #0049b0;
}

.adg3-editor .synchrony-tpi-2 {
	background-color: #00875a;
}

.adg3-editor .synchrony-tpi-3 {
	background-color: #ff8b00;
}

.adg3-editor .synchrony-tpi-4 {
	background-color: #de350b;
}

.adg3-editor .synchrony-tpi-5 {
	background-color: #5243aa;
}

.adg3-editor .synchrony-tpi-6 {
	background-color: #a5adba;
}

.adg3-editor .synchrony-tpi-7 {
	background-color: #2684ff;
}

.adg3-editor .synchrony-tpi-8 {
	background-color: #57d9a3;
}

.adg3-editor .synchrony-tpi-9 {
	background-color: #5e6c84;
}

.adg3-editor .synchrony-tpi-10 {
	background-color: #ff8f73;
}

.adg3-editor .synchrony-tpi-11 {
	background-color: #998dd9;
}

.adg3-editor .synchrony-tpi-0.synchrony-tps:before {
	border-left-color: #172b4d;
}

.adg3-editor .synchrony-tpi-0.synchrony-tpe:before {
	border-right-color: #172b4d;
}

.adg3-editor .synchrony-tpi-1.synchrony-tps:before {
	border-left-color: #0049b0;
}

.adg3-editor .synchrony-tpi-1.synchrony-tpe:before {
	border-right-color: #0049b0;
}

.adg3-editor .synchrony-tpi-2.synchrony-tps:before {
	border-left-color: #00875a;
}

.adg3-editor .synchrony-tpi-2.synchrony-tpe:before {
	border-right-color: #00875a;
}

.adg3-editor .synchrony-tpi-3.synchrony-tps:before {
	border-left-color: #ff8b00;
}

.adg3-editor .synchrony-tpi-3.synchrony-tpe:before {
	border-right-color: #ff8b00;
}

.adg3-editor .synchrony-tpi-4.synchrony-tps:before {
	border-left-color: #de350b;
}

.adg3-editor .synchrony-tpi-4.synchrony-tpe:before {
	border-right-color: #de350b;
}

.adg3-editor .synchrony-tpi-5.synchrony-tps:before {
	border-left-color: #5243aa;
}

.adg3-editor .synchrony-tpi-5.synchrony-tpe:before {
	border-right-color: #5243aa;
}

.adg3-editor .synchrony-tpi-6.synchrony-tps:before {
	border-left-color: #a5adba;
}

.adg3-editor .synchrony-tpi-6.synchrony-tpe:before {
	border-right-color: #a5adba;
}

.adg3-editor .synchrony-tpi-7.synchrony-tps:before {
	border-left-color: #2684ff;
}

.adg3-editor .synchrony-tpi-7.synchrony-tpe:before {
	border-right-color: #2684ff;
}

.adg3-editor .synchrony-tpi-8.synchrony-tps:before {
	border-left-color: #57d9a3;
}

.adg3-editor .synchrony-tpi-8.synchrony-tpe:before {
	border-right-color: #57d9a3;
}

.adg3-editor .synchrony-tpi-9.synchrony-tps:before {
	border-left-color: #5e6c84;
}

.adg3-editor .synchrony-tpi-9.synchrony-tpe:before {
	border-right-color: #5e6c84;
}

.adg3-editor .synchrony-tpi-10.synchrony-tps:before {
	border-left-color: #ff8f73;
}

.adg3-editor .synchrony-tpi-10.synchrony-tpe:before {
	border-right-color: #ff8f73;
}

.adg3-editor .synchrony-tpi-11.synchrony-tps:before {
	border-left-color: #998dd9;
}

.adg3-editor .synchrony-tpi-11.synchrony-tpe:before {
	border-right-color: #998dd9;
	/* stylelint-enable design-system/ensure-design-token-usage */
	/* Tables */
	/*
     table,
     table.confluenceTable {
     border: none;
     border-left: 1px solid #ddd;
     border-top: 1px solid #ddd;
     border-radius: 15px;
     border-collapse: separate;
     border-spacing: 0 0;
     .confluenceTh, .confluenceTd {
     border: none;
     border-right: 1px solid #ddd;
     border-bottom: 1px solid #ddd;
     }
     .confluenceTh {
     background-color: #F7F8FA;
     padding: 22px 12px;
     }
     .confluenceTd {
     padding: 32px 12px;
     }
     }
     */
}
`, "",{"version":3,"sources":["webpack://./../confluence-editor/src/adg3-styles/editor-content.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;CAWC;;AAED,8DAA8D;AAC9D;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;CAC3B,6DAA6D;CAC7D,WAAW;CACX;;;;;;;;;;;;;;;;;;;;;;MAsBK;AACN","sourcesContent":["/**\nContent styles is attached to the editor iframe and only affects the contents\n\n-tpi- classes are randomly assigned to telepointers, and may be used by multiple telepointers at the same time.\n\nTODO: we have added 10 of 12 new colors\ncolors in the spec that has not been added:\nR100 / #FF8F73 - .synchrony-tpi-10\nP100 / #998DD9 - .synchrony-tpi-11\nwe will need to create more synchrony classes to include (.synchrony-tpi-10 && .synchrony-tpi-11)\ndoes not exist yet.\n*/\n\n/* stylelint-disable design-system/ensure-design-token-usage */\n.adg3-editor .synchrony-tpi-0 {\n\tbackground-color: #172b4d;\n}\n\n.adg3-editor .synchrony-tpi-1 {\n\tbackground-color: #0049b0;\n}\n\n.adg3-editor .synchrony-tpi-2 {\n\tbackground-color: #00875a;\n}\n\n.adg3-editor .synchrony-tpi-3 {\n\tbackground-color: #ff8b00;\n}\n\n.adg3-editor .synchrony-tpi-4 {\n\tbackground-color: #de350b;\n}\n\n.adg3-editor .synchrony-tpi-5 {\n\tbackground-color: #5243aa;\n}\n\n.adg3-editor .synchrony-tpi-6 {\n\tbackground-color: #a5adba;\n}\n\n.adg3-editor .synchrony-tpi-7 {\n\tbackground-color: #2684ff;\n}\n\n.adg3-editor .synchrony-tpi-8 {\n\tbackground-color: #57d9a3;\n}\n\n.adg3-editor .synchrony-tpi-9 {\n\tbackground-color: #5e6c84;\n}\n\n.adg3-editor .synchrony-tpi-10 {\n\tbackground-color: #ff8f73;\n}\n\n.adg3-editor .synchrony-tpi-11 {\n\tbackground-color: #998dd9;\n}\n\n.adg3-editor .synchrony-tpi-0.synchrony-tps:before {\n\tborder-left-color: #172b4d;\n}\n\n.adg3-editor .synchrony-tpi-0.synchrony-tpe:before {\n\tborder-right-color: #172b4d;\n}\n\n.adg3-editor .synchrony-tpi-1.synchrony-tps:before {\n\tborder-left-color: #0049b0;\n}\n\n.adg3-editor .synchrony-tpi-1.synchrony-tpe:before {\n\tborder-right-color: #0049b0;\n}\n\n.adg3-editor .synchrony-tpi-2.synchrony-tps:before {\n\tborder-left-color: #00875a;\n}\n\n.adg3-editor .synchrony-tpi-2.synchrony-tpe:before {\n\tborder-right-color: #00875a;\n}\n\n.adg3-editor .synchrony-tpi-3.synchrony-tps:before {\n\tborder-left-color: #ff8b00;\n}\n\n.adg3-editor .synchrony-tpi-3.synchrony-tpe:before {\n\tborder-right-color: #ff8b00;\n}\n\n.adg3-editor .synchrony-tpi-4.synchrony-tps:before {\n\tborder-left-color: #de350b;\n}\n\n.adg3-editor .synchrony-tpi-4.synchrony-tpe:before {\n\tborder-right-color: #de350b;\n}\n\n.adg3-editor .synchrony-tpi-5.synchrony-tps:before {\n\tborder-left-color: #5243aa;\n}\n\n.adg3-editor .synchrony-tpi-5.synchrony-tpe:before {\n\tborder-right-color: #5243aa;\n}\n\n.adg3-editor .synchrony-tpi-6.synchrony-tps:before {\n\tborder-left-color: #a5adba;\n}\n\n.adg3-editor .synchrony-tpi-6.synchrony-tpe:before {\n\tborder-right-color: #a5adba;\n}\n\n.adg3-editor .synchrony-tpi-7.synchrony-tps:before {\n\tborder-left-color: #2684ff;\n}\n\n.adg3-editor .synchrony-tpi-7.synchrony-tpe:before {\n\tborder-right-color: #2684ff;\n}\n\n.adg3-editor .synchrony-tpi-8.synchrony-tps:before {\n\tborder-left-color: #57d9a3;\n}\n\n.adg3-editor .synchrony-tpi-8.synchrony-tpe:before {\n\tborder-right-color: #57d9a3;\n}\n\n.adg3-editor .synchrony-tpi-9.synchrony-tps:before {\n\tborder-left-color: #5e6c84;\n}\n\n.adg3-editor .synchrony-tpi-9.synchrony-tpe:before {\n\tborder-right-color: #5e6c84;\n}\n\n.adg3-editor .synchrony-tpi-10.synchrony-tps:before {\n\tborder-left-color: #ff8f73;\n}\n\n.adg3-editor .synchrony-tpi-10.synchrony-tpe:before {\n\tborder-right-color: #ff8f73;\n}\n\n.adg3-editor .synchrony-tpi-11.synchrony-tps:before {\n\tborder-left-color: #998dd9;\n}\n\n.adg3-editor .synchrony-tpi-11.synchrony-tpe:before {\n\tborder-right-color: #998dd9;\n\t/* stylelint-enable design-system/ensure-design-token-usage */\n\t/* Tables */\n\t/*\n     table,\n     table.confluenceTable {\n     border: none;\n     border-left: 1px solid #ddd;\n     border-top: 1px solid #ddd;\n     border-radius: 15px;\n     border-collapse: separate;\n     border-spacing: 0 0;\n     .confluenceTh, .confluenceTd {\n     border: none;\n     border-right: 1px solid #ddd;\n     border-bottom: 1px solid #ddd;\n     }\n     .confluenceTh {\n     background-color: #F7F8FA;\n     padding: 22px 12px;\n     }\n     .confluenceTd {\n     padding: 32px 12px;\n     }\n     }\n     */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
